export default "__VITE_ASSET__B$vjEQ2A__";